import * as React from 'react';
import { ITurnInfo } from '../../../../types/newbuilding';
import { CollapsedBlock } from '../../../CollapsedBlock';
import * as styles from './HousesByTurn.css';
import { UIText2 } from '@cian/ui-kit';

interface IHousesByTurnProps {
  housesByTurn: ITurnInfo[];
}

export const HousesByTurn: React.VFC<IHousesByTurnProps> = ({ housesByTurn }) => {
  return (
    <CollapsedBlock collapsedHeight={48}>
      <ul className={styles['list']}>
        {housesByTurn.map(turn => (
          <li key={turn.title}>
            <div className={styles['title']}>
              <UIText2 color="gray60_100">{turn.title}</UIText2>
            </div>

            <ul className={styles['list']}>
              {turn.finishDates &&
                turn.finishDates.map(date => (
                  <li key={date}>
                    <UIText2>{date}</UIText2>
                  </li>
                ))}
            </ul>
          </li>
        ))}
      </ul>
    </CollapsedBlock>
  );
};
